module.exports = __webpack_public_path__ + "img/register-type-bg.607b3e54.png";